import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ActivityReportInternshipLocationUseCaseInterface } from 'domain/usecases';

export class RemoteActivityReportInternshipLocation
  implements ActivityReportInternshipLocationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ActivityReportInternshipLocationUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ActivityReportInternshipLocationUseCaseInterface.Params,
  ): Promise<ActivityReportInternshipLocationUseCaseInterface.Result> {
    const { type, ...rest } = params;

    const requestUrl = generateUrl(`${this.url}/${type}`, rest as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',

      url: requestUrl,
      responseType: type === 2 ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(
          httpResponse.body.message ||
            'Algo inesperado aconteceu. Tente novamente em breve.',
        );
    }
  }
}
